module.exports = __webpack_public_path__ + "static/media/Post Street, San Francisco, CA2.6617ea96.jpg";